import { RouteProps } from "react-router-dom";
import MainPage from "../pages/DashboardPage/acadia";
import MyDocumentPage from "../pages/DashboardPage/acadia/MyDocumentPageIndex";
import ServicesPage from "../pages/DashboardPage/ServicesPage";
import DevPage from "../pages/DevPage";
import AdminPage from "./../pages/AdminPage";
import HomePage from "./../pages/HomePage";
import MaintenancePage from "./../pages/MaintenancePage";

import MyTasksMainPage from "../pages/DashboardPage/mytasks/index";
import MeetingsPageMain from "./../pages/DashboardPage/mytasks/meetingsPage/main";

import HelpPage from "src/pages/HelpPage";
import HelpPageMobile from "src/pages/HelpPageMobile";
import SettingsPage from "src/pages/SettingsPage";

import ReportsPage from "src/pages/Reports/ReportsPage";
import Vpo from "src/pages/DashboardPage/vpo/pages/vpo";
import Gos from "src/pages/DashboardPage/gos/pages/gos";
import Licenses from "src/pages/DashboardPage/gos/pages/licenses";
import NotificationPage from "src/pages/DashboardPage/acadia/notificationPage";
import { AuditsPage } from "src/pages/DashboardPage/mytasks/auditsPage/main";
import { MyTaskReportCard } from "src/pages/DashboardPage/mytasks/reports/MyTaskReportCard";
import MyTaskReportsPage from "src/pages/DashboardPage/mytasks/reports/MyTaskReportsPage";
import MTHelpPage from "src/pages/DashboardPage/mytasks/settingsAndHelps/MTHelpPage";
import MTSettingsPage from "src/pages/DashboardPage/mytasks/settingsAndHelps/MTSettingPage";
import HelpPageVPO from "src/pages/DashboardPage/vpo/pages/HelpPageVPO";
import ReportsMain from "src/pages/DashboardPage/vpo/pages/reports/ReportsMain";
import SettingsMain from "src/pages/DashboardPage/vpo/pages/SettingsMain";
import List5Way from "src/pages/DashboardPage/mytasks/list5Way/main";
import HelpPageGos from "src/pages/DashboardPage/gos/pages/HelpPageGos";
import SettingsPageGos from "src/pages/DashboardPage/gos/pages/SettingsPageGos";
import ReportsMainGos from "src/pages/DashboardPage/gos/pages/reports/ReportsMainGos";
import Gop from "src/pages/DashboardPage/gop/pages/gop";
import IncidentsPage from "src/pages/DashboardPage/mytasks/listIncidents/main";
import HelpGop from "src/pages/DashboardPage/gop/pages/HelpGop";
import SettingsGop from "src/pages/DashboardPage/gop/pages/SettingsGop";
import ReportsMainGop from "src/pages/DashboardPage/gop/pages/reports/ReportsMainGop";
import { SecurityPage } from "src/pages/DashboardPage/mytasks/listSecurity";
import MyTeamPage from "src/pages/DashboardPage/mytasks/myTeamPage/main";
import { FiveWhyType } from "src/api/config/systemSwitch";
import { MobileAuth } from "src/modules/authMobile/MobileAuth";
import ChangeApprovers from "src/pages/ChangeApprovers";
import List5SAudit from "src/pages/DashboardPage/mytasks/list5SAudit/main";
import { Triggers } from "src/pages/DashboardPage/mytasks/triggers";

export const rootRoutes: RouteProps[] = [
  {
    path: "/",
    Component: HomePage,
  },
  {
    path: "/admin",
    Component: AdminPage,
  },
  {
    path: "/dashboard/:id/*",
    Component: ServicesPage,
  },
  {
    path: "/dev",
    Component: DevPage,
  },
  {
    path: "/tech",
    Component: () => <MaintenancePage type="main" />,
  },
  {
    path: "/mobile-auth",
    Component: MobileAuth,
  }
];

export const systemRoutes: Record<string, RouteProps[]> = {
  "1": [
    {
      path: "/",
      Component: MainPage,
    },
    {
      path: "/documents",
      Component: MyDocumentPage,
    },
    {
      path: "/notification",
      Component: NotificationPage,
    },
    {
      path: "/reports/:reportID?",
      Component: ReportsPage,
    },
    {
      path: "/settings",
      Component: SettingsPage,
    },
    {
      path: "/help",
      Component: HelpPageMobile,
    },
    {
      path: "/change-approvers",
      Component: ChangeApprovers,
    }
  ],
  "2": [
    {
      path: "/",
      Component: () => <Gop />,
    },
    {
      path: "/reports/:reportID?",
      Component: ReportsMainGop,
    },
    {
      path: "/settings",
      Component: () => <SettingsGop />,
    },
    {
      path: "/help",
      Component: HelpGop,
    },
  ],
  "3": [
    {
      path: "/",
      Component: MyTasksMainPage,
    },
    {
      path: "/my-team",
      Component: () => <MyTeamPage />,
    },
    {
      path: "/meetings",
      Component: MeetingsPageMain,
    },
    {
      path: "/5-whys",
      Component: () => <List5Way type={FiveWhyType} />,
    },
    {
      path: "/5S-audit",
      Component: () => <List5SAudit />,
    },
    {
      path: "/deviation-reports",
      Component: () => <List5Way type="DeviationReport" />,
    },
    {
      path: "/behavioral-audit",
      Component: () => <AuditsPage />,
    },
    {
      path: "/incidents-and-nonconformities",
      Component: () => <IncidentsPage />,
    },
    {
      path: "/incidents-security",
      Component: () => <SecurityPage />,
    },
    {
      path: "/settings/triggers-five-why",
      Component: () => <Triggers type={FiveWhyType} />,
    },
    {
      path: "/settings/triggers-deviation-report",
      Component: () => <Triggers type="DeviationReport" />,
    },
    {
      path: "/reports",
      Component: MyTaskReportsPage,
    },
    {
      path: "/reports/:reportID",
      Component: MyTaskReportCard,
    },
    {
      path: "/settings",
      Component: MTSettingsPage,
    },
    {
      path: "/help",
      Component: MTHelpPage,
    },
  ],
  "4": [
    {
      path: "/",
      Component: () => <Gos />,
    },
    {
      path: "/licenses",
      Component: () => <Licenses />,
    },
    {
      path: "/reports/:reportID?",
      Component: ReportsMainGos,
    },
    {
      path: "/settings",
      Component: () => <SettingsPageGos />,
    },
    {
      path: "/help",
      Component: HelpPageGos,
    },
  ],
  "5": [
    {
      path: "/",
      Component: () => <div>Спутник</div>,
    },
  ],
  "6": [
    {
      path: "/",
      Component: () => <Vpo />,
    },
    {
      path: "/reports/:reportID?",
      Component: ReportsMain,
    },
    {
      path: "/settings",
      Component: () => <SettingsMain />,
    },
    {
      path: "/help",
      Component: HelpPageVPO,
    },
  ]
};
